import { Component, Input } from '@angular/core';
import { InternetProduct } from '@dch/products-business-logic';
import { openProductURL } from '../../../shared/util/my-product-apps';
import { Router } from '@angular/router';
import { savePiiCloudServiceId } from '../../../../shared/pii/pii.utils';

@Component({
  selector: 'mprd-my-internet-apps',
  templateUrl: './my-internet-apps.component.html',
})
export class MyInternetAppsComponent {
  @Input() internetProduct: InternetProduct;
  openUrlOrApp = openProductURL;
  pageRouter;

  constructor(router: Router) {
    this.pageRouter = router;
  }

  redirectToCloud() {
    savePiiCloudServiceId(this.internetProduct.clouds[0].accessNumber);
    this.openUrlOrApp(this.internetProduct.clouds[0], this.pageRouter);
  }
}
